import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/close_icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-45e54384")

_pushScopeId("data-v-45e54384")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-display-area" }
const _hoisted_3 = {
  key: 0,
  class: "dialog-box-top"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "dialog-box-top-button-icon",
  src: _imports_0
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "dialog-box-topspacer"
}
const _hoisted_6 = {
  key: 0,
  class: "dialog-box-contents-typeimage"
}
const _hoisted_7 = {
  key: 1,
  class: "dialog-box-contents-title"
}
const _hoisted_8 = {
  key: 2,
  class: "dialog-box-contents-titlemessagespacer"
}
const _hoisted_9 = {
  key: 0,
  class: "dialog-box-contents-messageimage-spacer"
}
const _hoisted_10 = {
  key: 1,
  class: "dialog-box-contents-messageimage-image"
}
const _hoisted_11 = {
  key: 2,
  class: "dialog-box-contents-messageimage-betweenspacer"
}
const _hoisted_12 = {
  key: 2,
  class: "dialog-box-bottom"
}
const _hoisted_13 = {
  key: 0,
  class: "dialog-box-bottom-select"
}
const _hoisted_14 = {
  key: 0,
  class: "dialog-box-bottom-select-row"
}
const _hoisted_15 = { class: "dialog-box-bottom-select-row-negative-title" }
const _hoisted_16 = { class: "dialog-box-bottom-select-row-positive-title" }
const _hoisted_17 = {
  key: 1,
  class: "dialog-box-bottom-select-column"
}
const _hoisted_18 = { class: "dialog-box-bottom-select-column-positive-title" }
const _hoisted_19 = { class: "dialog-box-bottom-select-column-negative-title" }
const _hoisted_20 = {
  key: 1,
  class: "dialog-box-bottom-spacer"
}
const _hoisted_21 = {
  key: 2,
  class: "dialog-box-bottom-textbutton"
}
const _hoisted_22 = { class: "dialog-box-bottom-textbutton-button-title" }
const _hoisted_23 = {
  key: 3,
  class: "dialog-box-bottomspacer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", {
              class: "dialog-box",
              style: _ctx.styleDialogHeight
            }, [
              (_ctx.isTopDisplay)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    (_ctx.isTopCloseButton)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "dialog-box-top-button",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeClicked(...args)))
                        }, [
                          _hoisted_4
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isMessageOnly)
                ? (_openBlock(), _createBlock("div", _hoisted_5))
                : _createCommentVNode("", true),
              _createVNode("div", {
                class: "dialog-box-contents",
                style: _ctx.styleContentsHeight
              }, [
                (_ctx.isTypeImageDisplay)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("img", {
                        class: "dialog-box-contents-typeimage-image",
                        src: _ctx.typeImage()
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDialogTitle)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("div", {
                        innerHTML: _ctx.title,
                        class: "dialog-box-contents-title-text"
                      }, null, 8, ["innerHTML"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isTitleAndMessage)
                  ? (_openBlock(), _createBlock("div", _hoisted_8))
                  : _createCommentVNode("", true),
                (_ctx.isExistMessageImage)
                  ? (_openBlock(), _createBlock("div", {
                      key: 3,
                      class: "dialog-box-contents-messageimage",
                      style: _ctx.styleImageMessageHeight
                    }, [
                      (_ctx.isNeedTitleBottomMargin)
                        ? (_openBlock(), _createBlock("div", _hoisted_9))
                        : _createCommentVNode("", true),
                      (_ctx.isDialogMainImageDisplay)
                        ? (_openBlock(), _createBlock("div", _hoisted_10, [
                            _createVNode("img", {
                              class: "dialog-box-contents-messageimage-image-image",
                              src: _ctx.dialogMainImage()
                            }, null, 8, ["src"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isImageAndMessage)
                        ? (_openBlock(), _createBlock("div", _hoisted_11))
                        : _createCommentVNode("", true),
                      (_ctx.isNormalMessage)
                        ? (_openBlock(), _createBlock("span", {
                            key: 3,
                            class: "dialog-box-contents-messageimage-normaltext",
                            style: _ctx.styleMessageAlignment
                          }, _toDisplayString(_ctx.message), 5))
                        : _createCommentVNode("", true),
                      (_ctx.isHTMLMessage)
                        ? (_openBlock(), _createBlock("div", {
                            key: 4,
                            innerHTML: _ctx.htmlMessage,
                            class: "dialog-box-contents-messageimage-htmltext",
                            style: _ctx.styleMessageAlignment
                          }, null, 12, ["innerHTML"]))
                        : _createCommentVNode("", true)
                    ], 4))
                  : _createCommentVNode("", true)
              ], 4),
              (_ctx.isBottomDisplay)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    (_ctx.isDisplayBottomSelection)
                      ? (_openBlock(), _createBlock("div", _hoisted_13, [
                          (_ctx.isBottomButtonRowDirection)
                            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                (_ctx.isNegativeButtonDisplay)
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 0,
                                      class: "dialog-box-bottom-select-row-negative",
                                      style: _ctx.styleRowNegativeButton,
                                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.negativeClicked(...args)))
                                    }, [
                                      _createVNode("div", _hoisted_15, _toDisplayString(_ctx.negativeLabel), 1)
                                    ], 4))
                                  : _createCommentVNode("", true),
                                (_ctx.isPositiveButtonDisplay)
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 1,
                                      class: "dialog-box-bottom-select-row-positive",
                                      style: _ctx.styleRowPositiveButton,
                                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.positiveClicked(...args)))
                                    }, [
                                      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.positiveLabel), 1)
                                    ], 4))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_17, [
                                (_ctx.isPositiveButtonDisplay)
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 0,
                                      class: "dialog-box-bottom-select-column-positive",
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.positiveClicked(...args)))
                                    }, [
                                      _createVNode("div", _hoisted_18, _toDisplayString(_ctx.positiveLabel), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isNegativeButtonDisplay)
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 1,
                                      class: "dialog-box-bottom-select-column-negative",
                                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.negativeClicked(...args)))
                                    }, [
                                      _createVNode("div", _hoisted_19, _toDisplayString(_ctx.negativeLabel), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isExistNormalButtonAndTextButton)
                      ? (_openBlock(), _createBlock("div", _hoisted_20))
                      : _createCommentVNode("", true),
                    (_ctx.isDisplayBottomTextButton)
                      ? (_openBlock(), _createBlock("div", _hoisted_21, [
                          _createVNode("div", {
                            class: "dialog-box-bottom-textbutton-button",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.bottomTextClicked(...args)))
                          }, [
                            _createVNode("div", _hoisted_22, _toDisplayString(_ctx.textButtonTitle), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isMessageOnly)
                ? (_openBlock(), _createBlock("div", _hoisted_23))
                : _createCommentVNode("", true)
            ], 4)
          ])
        ], 512), [
          [_vShow, _ctx.isShowDialog]
        ])
      ]),
      _: 1
    })
  ]))
})